export default __webpack_public_path__ + "static/media/Grimward.18ec327b.jpg";